import { render } from "./Employees.vue?vue&type=template&id=5f91c40c&scoped=true"
import script from "./Employees.vue?vue&type=script&lang=js"
export * from "./Employees.vue?vue&type=script&lang=js"

import "./Employees.vue?vue&type=style&index=0&id=5f91c40c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f91c40c"]])

export default __exports__